import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/landing/Reveal";
import { SERVICE_AREAS, AREA_GROUPS, COMPANY } from "@/data";

const cityBySlug = (slug) => SERVICE_AREAS.find((a) => a.slug === slug);

export default function ServiceAreasHub() {
  return (
    <>
      <Seo
        title="Areas We Serve in North & South Carolina | Almeida's Home Services"
        description="Almeida's Home Services serves North and South Carolina: Charlotte, Pineville, Matthews, Fort Mill, Rock Hill and nearby towns. Free estimates."
        path="/service-areas"
      />

      <section className="relative bg-navy-dark pt-32 pb-20 md:pt-40 md:pb-24">
        <div className="max-w-[1100px] mx-auto px-5 md:px-12">
          <Reveal>
            <Link to="/" className="font-body text-gold/80 hover:text-gold text-sm">← Home</Link>
            <h1 className="mt-5 font-display font-bold uppercase text-white text-4xl md:text-6xl leading-[0.92] tracking-tight max-w-[20ch]">
              Areas We Serve in North & South Carolina
            </h1>
            <p className="mt-6 max-w-2xl font-body text-white/75 text-lg leading-relaxed">
              Based in the Charlotte area, we serve homeowners and businesses on both sides of the state line.
              Don't see your town? Call us at{" "}
              <a href={`tel:${COMPANY.phoneRaw}`} className="text-gold font-semibold hover:underline">{COMPANY.phone}</a>.
              We regularly travel across the region for larger projects.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-[1100px] mx-auto px-5 md:px-12 space-y-14">
          {AREA_GROUPS.map((g, gi) => (
            <Reveal key={g.state} delay={gi * 0.1}>
              <div>
                <h2 className="font-display font-bold uppercase text-navy text-2xl md:text-4xl tracking-tight">{g.state}</h2>
                <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {g.cities.map((slug) => {
                    const a = cityBySlug(slug);
                    return (
                      <Link
                        key={slug}
                        to={`/service-areas/${slug}`}
                        data-testid={`hub-city-${slug}`}
                        className="group bg-cloud rounded-2xl p-6 hover:bg-navy hover:-translate-y-1 transition-[background-color,transform] duration-300"
                      >
                        <div className="w-11 h-11 rounded-full bg-royal flex items-center justify-center mb-4 group-hover:bg-gold transition-colors">
                          <MapPin size={20} className="text-white group-hover:text-navy-dark" />
                        </div>
                        <h3 className="font-display font-semibold text-navy text-xl group-hover:text-white">{a.city}, {a.state}</h3>
                        <span className="mt-2 inline-flex items-center gap-1 font-body text-royal text-sm font-semibold group-hover:text-gold">
                          View area <ArrowRight size={15} />
                        </span>
                      </Link>
                    );
                  })}
                </div>
                <p className="mt-5 font-body text-navy/55 text-sm">
                  Also serving: {g.extra.join(" · ")}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
